import { PoolDetails } from "@/models/pool-details.model.ts";
import { Dialog } from "@capacitor/dialog";
import { computed, ComputedRef, ref } from "vue";
import i18n from "@/core/i18n.ts";

const KEY = "kwa_ble_pools";

const promptPoolName = async (defaultName?: string): Promise<string> => {
  const { t } = i18n.global;
  let name = defaultName ?? "";
  let result;
  do {
    result = await Dialog.prompt({
      message: t("BleChoosePoolNameText"),
      inputText: defaultName,
    });
    if (!result.cancelled) name = result.value.trim();
  } while (!name);
  return name;
};

export const storeBlePool = async (
  deviceId: string,
  poolDetails?: Partial<PoolDetails> & {
    localNickname?: string;
    token?: string;
  },
  options?: { autoConnect?: boolean; skipNickname?: boolean }
) => {
  const storedPools = readFromLocalStorage();

  const existing = storedPools.find((pool) => pool.deviceId === deviceId);

  localStorage.setItem(
    KEY,
    JSON.stringify([
      ...storedPools.filter((pool) => pool.deviceId !== deviceId),
      {
        ...existing,
        ...poolDetails,
        deviceId,
        localNickname: options?.skipNickname
          ? undefined
          : poolDetails?.localNickname ??
            existing?.localNickname ??
            (await promptPoolName(poolDetails?.poolNickname)),
        autoConnect: options?.autoConnect ?? existing?.autoConnect ?? true,
      },
    ])
  );

  console.log("storing pool5");
  onPoolsChanged();
};

export const renamePool = async (pool: {
  deviceId: string;
  localNickname?: string;
  poolNickname?: string;
}) => {
  const name = await promptPoolName(pool.localNickname || pool.poolNickname);
  await storeBlePool(pool.deviceId, { localNickname: name });
};

export const removeBlePool = (deviceId: string) => {
  const storedPools = readFromLocalStorage();
  localStorage.setItem(
    KEY,
    JSON.stringify(storedPools.filter((pool) => pool.deviceId !== deviceId))
  );
  onPoolsChanged();
};

const readFromLocalStorage = (): (PoolDetails & {
  deviceId: string;
  autoConnect: boolean;
  localNickname: string;
  token: string;
})[] => {
  return JSON.parse(localStorage.getItem(KEY) || "[]");
};

const _storedPools = ref(readFromLocalStorage());

const onPoolsChanged = () => {
  _storedPools.value = readFromLocalStorage();
};

export const useStoredBlePools = () => _storedPools;

export const useStoredBlePool = (deviceId: ComputedRef<string>) => {
  return computed(() =>
    _storedPools.value.find((pool) => pool.deviceId === deviceId.value)
  );
};
